<template>
    <div class="ban-component swiper-container">
        <div class="swiper-wrapper">
            <slot></slot>
        </div>
        <div class="swiper-pagination" slot="pagination"></div>
    </div>
</template>

<script>
// swier 组件
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper-bundle.min.css'
export default {
    mounted() {
        new Swiper ('.ban-component', {
            direction: 'horizontal', // 水平切换选项
            loop: true, // 循环模式选项
            effect : 'slide',
            autoplay: {
                delay: 3000,
                stopOnLastSlide: false,
                disableOnInteraction: false
            },
            // 如果需要分页器
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
                // progressbarFillClass : 'my-pagination-progressbar-fill'
            }
        });
    }
}
</script>
<style lang="less">
// 初始化设计图尺寸
@rem: 40rem;
@w100: (620/@rem);
.ban-component{
    width: (600/@rem);
    height: auto;
    border-radius: (15/@rem);
    a{
        display: block;
        img{
            display: block;
            width: 100%;
            border-radius: (15/@rem);
        }
    }
    .swiper-pagination-progressbar-fill{
        background: #d83538;
    }
}
</style>
